import {
  BotIcon,
  CpuIcon,
  PlugZapIcon,
  SlidersHorizontalIcon,
  Workflow as WorkflowIcon,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { UserAvatar } from '@/shared/components/UserAvatar';
import type { BreakdownEntry } from '@/lib/api/generated/model';

/**
 * What leads a row of the Where it went table (specs 219, 225): the kind of thing it
 * counts, so the groupings read apart at a glance. Decorative — the table hides them
 * from assistive technology, and each row's name already says what it is.
 */
function tile(Icon: LucideIcon) {
  return (
    <span className="bg-muted text-muted-foreground grid size-7 place-items-center rounded-md">
      <Icon className="size-4" strokeWidth={1.75} />
    </span>
  );
}

export const workflowMarker = () => tile(WorkflowIcon);

export const modelMarker = () => tile(CpuIcon);

/** An AI profile (spec 225). */
export const profileMarker = () => tile(SlidersHorizontalIcon);

/** An AI connection (spec 225). */
export const connectionMarker = () => tile(PlugZapIcon);

/** A person's disc, keyed on their id; the unattributed row ("Automatic") gets a bot. */
export function personMarker(entry: BreakdownEntry) {
  return entry.key === null ? (
    tile(BotIcon)
  ) : (
    <UserAvatar
      id={entry.key}
      displayName={entry.label}
      email=""
      className="size-7 text-xs"
    />
  );
}
